
@switch (activeSignButton$ | async) {
  @case ('SIGN_IN') {
    <sign-in-ui
      [signInForm]="getFormGroup('signInForm')"
      (forgotPasswordEmitter)="forgotPassword()"
      (signUpViewEmitter)="signUpView()"
    (signInSubmitEmitter)="signInSubmit()"></sign-in-ui>
  }
  @case ('SIGN_UP') {
    <sign-up-ui
      [signUpForm]="getFormGroup('signUpForm')"
      [countries]="countries$ | async"
      [states]="states$ | async"
      (signInViewEmitter)="signInView()"
      (signUpSubmitEmitter)="signUpSubmit()"
      (onTermsEmitter)="onTermsEmitter()"
      (onPrivacyEmitter)="onPrivacyEmitter()"
      (selectedCountry)="selectedCountry($event)"
    (selectedState)="selectedState($event)"></sign-up-ui>
  }
  @case ('FORGOT_PASSWORD') {
    <forgot-password-ui
      [isOTPRequested]="isOTPRequested$ | async"
      [fpForm]="getFormGroup('fpForm')"
      (requestOTPEmitter)="requestOTP($event)"
    (resetPasswordSubmitEmitter)="resetPasswordSubmit()"></forgot-password-ui>
  }
  @case ('RESET_UPDATE') {
    <reset-update (signInViewEmitter)="signInView()"></reset-update>
  }
  @case ('MOBILE_MENU') {
    <mobile-menu
      (signInViewEmitter)="signInView()"
      (signUpViewEmitter)="signUpView()"
    (closeDialogMenuEmitter)="closeDialogMenu()"></mobile-menu>
  }
}
